import React from 'react';
import { motion } from 'framer-motion';
import ContactForm from '../components/ContactFormElevated';
import ParallaxBackground from '../components/ParallaxBackground';

const Renters = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen"
    >
      <ParallaxBackground 
        image="/images/boathouse-row.jpg"
        className="py-32"
        overlay={true}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 text-white">
            Renters
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto">
            Specialized services to assist renters throughout the rental process
          </p>
        </div>
      </ParallaxBackground>

      <section className="py-16 bg-eagle-light-gray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-eagle-dark mb-4">
              Renter Services
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              As a renter, finding the right rental property and ensuring a smooth leasing process is essential for a positive renting experience. At Eagle Closing, we offer specialized services to assist renters like you, providing guidance and support throughout the rental process.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: 'Lease Agreement Review',
                description: 'Our professionals meticulously review lease agreements, ensuring that all terms and conditions are accurately reflected and in compliance with local laws. We help protect your rights as a tenant and ensure a fair and transparent leasing process.',
              },
              {
                title: 'Document Assistance',
                  description: 'We provide guidance and support in understanding and completing necessary rental documents. Our team can help you navigate through the paperwork involved in renting, ensuring that you have a clear understanding of the documents you\'re signing.',
              },
              {
                title: 'Communication and Coordination',
                description: 'We act as a central point of contact, facilitating communication between you and the landlord or property management company. Our team ensures that all parties are informed and work together smoothly throughout the leasing process.',
              },
              {
                title: 'Timely and Efficient Lease Execution',
                description: 'We understand the importance of timely lease execution. Our streamlined processes and commitment to efficiency help ensure that lease agreements are processed promptly, allowing you to move into your new rental property as planned.',
              },
            ].map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
              >
                <h3 className="text-xl font-semibold text-eagle-dark mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600">
                  {service.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <p className="text-lg text-gray-700 mb-8">
              At Eagle Closing, we believe that every renter deserves a positive and seamless experience. Our goal is to provide you with the support and guidance you need to navigate the rental process with confidence.
            </p>
            <p className="text-lg text-gray-700 mb-8">
              Contact us today to learn more about our renter services and how we can assist you in achieving a successful leasing experience. Trust Eagle Closing to be your reliable partner throughout your renting journey, ensuring a smooth transition into your new rental property.
            </p>
          </div>
        </div>
      </section>
      
      {/* Contact Form with Parallax */}
      <ContactForm backgroundImage="/images/benjamin-franklin-bridge.jpg" />
    </motion.div>
  );
};

export default Renters;

